export default function createLoadingComponent() {
  // TODO: loading
}
